<template>
  <div style="position: relative; cursor: pointer">
    <input v-model="input" disabled type="text" />
    <div
      style="position: absolute; left: 0; right: 0; top: 0; bottom: 0"
      @click="
        if (!disabled) {
          dialogCardReaderVisible = true
        }
      "
    ></div>

    <CardReaderDialog v-model="dialogCardReaderVisible" @change="onChange" />
  </div>
</template>

<script>
import CardReaderDialog from './CardReaderDialog.vue'

export default {
  components: {
    CardReaderDialog
  },

  data() {
    return {
      dialogCardReaderVisible: false,

      input: null,
      colName: null,
      disabled: null
    }
  },

  beforeMount() {
    // console.log(this.params)
    this.params.value ? (this.input = this.params.value) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    this.disabled = this.params.disabled
  },

  methods: {
    onChange(value) {
      this.input = value
      // call parent context method
      this.params.context.componentParent.changeInput(
        this.colName,
        this.params,
        this.input
      )
      this.dialogCardReaderVisible = false
    }
  }
}
</script>
